export type GuestOrderingClosedReason = 'OFFLINE' | 'OUTSIDE_HOURS' | null;

export interface GuestOrderingStatus {
  guestOrdersOnline?: boolean;
  openNow?: boolean;
  acceptingGuestOrders?: boolean;
  closedReason?: GuestOrderingClosedReason | string | null;
  message?: string | null;
}

export function isAcceptingGuestOrders(status?: GuestOrderingStatus | null): boolean {
  if (!status) return true;
  if (status.guestOrdersOnline === false || status.closedReason === 'OFFLINE') return false;
  return status.acceptingGuestOrders !== false;
}

export function isGuestOrderingOffline(status?: GuestOrderingStatus | null): boolean {
  return status?.guestOrdersOnline === false || status?.closedReason === 'OFFLINE';
}

export function guestOrderingMessage(status?: GuestOrderingStatus | null): string | null {
  if (isAcceptingGuestOrders(status)) return null;
  if (status?.message) return status.message;
  if (isGuestOrderingOffline(status)) {
    return 'This restaurant is offline and is not accepting customer orders right now.';
  }
  return 'This restaurant is closed. Please place your order during opening hours.';
}

export function guestOrderingTitle(status?: GuestOrderingStatus | null): string | null {
  if (isAcceptingGuestOrders(status)) return null;
  return isGuestOrderingOffline(status) ? 'Currently offline' : 'Closed right now';
}

export function guestOrderingBody(status?: GuestOrderingStatus | null): string | null {
  if (isAcceptingGuestOrders(status)) return null;
  if (isGuestOrderingOffline(status)) {
    return 'Customer orders are paused. Takeaway and dine-in checkout are unavailable.';
  }
  return 'This restaurant is outside opening hours, so new customer orders cannot be placed.';
}

export function guestOrderingHint(status?: GuestOrderingStatus | null): string | null {
  if (isAcceptingGuestOrders(status)) return null;
  if (isGuestOrderingOffline(status)) {
    return 'You can still browse the menu. Checkout will unlock when they are back online.';
  }
  return 'You can still browse the menu and come back during opening hours.';
}
